import { SESSION_META } from './statusMeta';
import type { SessionState } from '../types';
import { Icon } from './Icon';

export function StatusPill({ state, size = 'md' }: { state: SessionState; size?: 'sm' | 'md' }) {
  const m = SESSION_META[state];
  const sm = size === 'sm';
  return (
    <span
      title={m.label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: sm ? 6 : 8,
        height: sm ? 20 : 28,
        padding: sm ? '0 8px' : '0 12px',
        borderRadius: 'var(--r-full)',
        background: m.soft,
        color: m.color,
        border: m.bordered ? `1px solid ${m.color}` : 'none',
        font: sm ? '600 12px/16px var(--font-ui)' : '500 14px/20px var(--font-ui)',
        whiteSpace: 'nowrap',
      }}
    >
      <Icon name={m.icon} size={sm ? 12 : 14} />
      <span
        className={
          m.anim === 'pulse' ? 'anim-pulse' : m.anim === 'slow' ? 'anim-pulse-slow' : undefined
        }
        style={{
          width: sm ? 6 : 8,
          height: sm ? 6 : 8,
          borderRadius: '50%',
          background: 'currentColor',
          flex: 'none',
        }}
      />
      {m.label}
    </span>
  );
}
